import React from "react";
import styles from "./Presidenti.module.scss";
import President from "./../../assets/images/presidenti.jpeg";
import Sekretari from "./../../assets/images/marcuswidner.jpg";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Presidenti = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const isPresident = location.pathname === "/presidenti";

  const dataToRender = isPresident
      ? {
        image: President,
        title: t("president.title"),
        descriptionKeys: [
          "president.description.1",
          "president.description.2",
          "president.description.3",
        ],
      }
      : {
        image: Sekretari,
        title: t("secretary.title"),
        descriptionKeys: [
          "secretary.description.1",
          "secretary.description.2",
        ],
      };

  return (
      <div className={styles.MainWrapper}>
        <div className={styles.PrimaryTitleWrapper}>
          <img
              src={dataToRender.image}
              alt={dataToRender.title}
              className={styles.FirstImage}
          />
          <div className={styles.Content}>
            <h1>{dataToRender.title}</h1>
            <div className={styles.Description}>
              {dataToRender.descriptionKeys.map((key, index) => (
                  <h4 key={index}>{t(key)}</h4>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};

export default Presidenti;
